<script>
  import Post from "../../components/forum/Post.svelte";

  export let params;
</script>

<section class="forum">
  <Post id={params.id} />
</section>
